import { ausAdresse, inAdresse } from './teile/adresse.ts';
import { rollbereich } from './teile/merkplatz.ts';
import { useEffect, useRef, useState } from 'react';
import { api, darf, type Anmelder, type Bauteil } from './api.ts';
import Anmeldung, { Einladung, PasswortWechsel } from './seiten/Anmeldung.tsx';
import Warteseite from './seiten/Warteseite.tsx';
import { FaktorAbfrage, FaktorEinrichtung } from './seiten/Faktor.tsx';
import Arbeitsliste from './seiten/Arbeitsliste.tsx';
import Eingang from './seiten/Eingang.tsx';
import Postfach from './seiten/Postfach.tsx';
import Auftragsakte from './seiten/Auftragsakte.tsx';
import Handbuch from './seiten/Handbuch.tsx';
import Changelog from './seiten/Changelog.tsx';
import Vordrucke from './seiten/Vordrucke.tsx';
import Terminplaner from './seiten/Terminplaner.tsx';
import Behoerden from './seiten/Behoerden.tsx';
import Abrechnung from './seiten/Abrechnung.tsx';
import Rechnungswesen from './seiten/Rechnungswesen.tsx';
import Gbgs from './seiten/Gbgs.tsx';
import Papierkorb from './seiten/Papierkorb.tsx';
import LebVerzeichnis from './seiten/LebVerzeichnis.tsx';
import Adressbuch from './seiten/Adressbuch.tsx';
import Rotberichtigungen from './seiten/Rotberichtigungen.tsx';
/* EIN EIGENER ORT FÜR DIE RECHNUNGSPRÜFUNG (21.09.2026).
   Marvin: „wo ist denn der menüpunkt um die rechnungen gegenzuprüfen? dafür
   brauche ich einen extra punkt." Sie war der 4. Reiter unter „Aufmaß und
   Abrechnung" - und damit für jeden, der sie suchte, nicht vorhanden. */
import Freigaben from './seiten/Freigaben.tsx';
import Material from './seiten/Material.tsx';
import Gebuehren from './seiten/Gebuehren.tsx';
import RechnungenBezahlen from './seiten/RechnungenBezahlen.tsx';
import Bankverbindungen from './seiten/Bankverbindungen.tsx';
/* WAS DIE TELEKOM UNS ZAHLT. Marvin, 22.09.2026: „So kann ich dann in einem
   weiteren Punkt prüfen Welche lebs noch nicht abgerechnet wurden und der
   Telekom eine Liste senden." */
import LebAbrechnung from './seiten/LebAbrechnung.tsx';
import Verfuegbarkeit from './seiten/Verfuegbarkeit.tsx';
import { Auswertung, Kapazitaet, Nachrichten } from './seiten/Zahlen.tsx';
import Stammdaten from './seiten/Stammdaten.tsx';
import { Benutzer, Konfiguration } from './seiten/Verwaltung.tsx';
import Schnittstelle from './seiten/Schnittstelle.tsx';
import Systemzustand from './seiten/Systemzustand.tsx';
import Protokoll from './seiten/Protokoll.tsx';
import Automatik from './seiten/Automatik.tsx';
import { StandKlein } from './teile/Stand.tsx';
import { Puls, RechnerMelden } from './teile/Puls.tsx';
import { Marke } from './teile/Marke.tsx';
import { Glocke } from './teile/Glocke.tsx';
import { Dialog } from './teile/Formular.tsx';
import { MeineSicherheit } from './seiten/Faktor.tsx';
import { Gesicht } from './teile/Person.tsx';
import { beobachteKlebehoehe, beobachteKopfleiste } from './teile/klebeband.ts';
import { beobachteTabellen } from './teile/tabellenbeschriftung.ts';
import { Ne4Teams, Ne4Verwaltung } from './seiten/Ne4.tsx';
import { Ne3Karte } from './seiten/Ne3Karte.tsx';
import { Ne4Auftraege, Ne4Anrufliste } from './seiten/Ne4Arbeit.tsx';
import { Ne4Planung, Ne4Gbgs } from './seiten/Ne4Planung.tsx';
import { Ne4Tagesplan } from './seiten/Ne4Tagesplan.tsx';
import { Ne4FirmenAuftraege } from './seiten/Ne4Firma.tsx';
import { Ne4Karte } from './seiten/Ne4Karte.tsx';
import { Ne4Zahlen } from './seiten/Ne4Zahlen.tsx';

/* `initialen` STAND HIER UND WIRD JETZT AN DREI STELLEN GEBRAUCHT: unten
   links, in „Meine Anmeldung" und neben jedem Eintrag der Auftragsinfo. Sie
   steht deshalb EINMAL, in `teile/Person.tsx`, zusammen mit dem Kreis, der
   sie zeigt. Drei Abschriften heissen, dass die dritte irgendwann etwas
   anderes zeigt. */

export default function App() {
  const [ich, setIch] = useState<Anmelder | null>(null);
  const [laedt, setLaedt] = useState(true);
  const [bauplan, setBauplan] = useState<Bauteil[]>([]);
  /* DER PLATZ ÜBERLEBT DAS NEULADEN (.217), siehe `teile/adresse.ts`. */
  const start = ausAdresse();
  const hashFolger = useRef<() => void>(() => {});
  const rollMerk = useRef<Record<string, number>>({});
  const [wo, setWo] = useState(start.wo);
  /* Wer zuletzt angemeldet war: ein neuer Zugang (Anmelden, „Einloggen als") startet in seiner Arbeitsliste. */
  const zuletztZugang = useRef<string | null>(null);
  const [akte, setAkte] = useState<string | null>(start.akte);
  /* DER BEREICH (.333). Marvin, 08.10.2026: „Ich bin für die Variante B bei
     der Trennung von NE3 und NE4 über den Weg des Bereiches für die Leute,
     die den Zugang haben." Er steht in der Adresse (#/ne4/...), sonst gilt
     der zuletzt gewählte, sonst der erste, den dieser Zugang hat. Was er
     zeigt, entscheidet der Server über `/bauplan?bereich=`; hier steht nur
     die Wahl. */
  const [bereich, setBereich] = useState<string | null>(() => {
    if (start.bereich) return start.bereich;
    try { return localStorage.getItem('mds.bereich'); } catch { return null; }
  });
  /* WAS OBEN KLEBT, WIRD GEMESSEN.
     ------------------------------------------------------------------------
     ORIGINALTEXT MARVIN (03.09.2026)
       „auch bei den anderen seiten soll das menüband oben stehen bleiben wenn
        die seite durchgescrollt wird."

     Die Reiterleiste klebt unter dem Kopf, und wie hoch der ist, hängt am
     Bildschirm und an der Fensterbreite. Gemessen wird deshalb, statt eine
     Zahl ins Stylesheet zu schreiben - siehe `teile/klebeband.ts`. */
  const buehne = useRef<HTMLElement>(null);
  useEffect(() => {
    if (!buehne.current) return;
    return beobachteKlebehoehe(buehne.current);
  }, [ich]);

  /* JEDE ZELLE BEKOMMT IHRE SPALTENÜBERSCHRIFT - EINMAL, HIER.
     Auf einem schmalen Bildschirm wird aus jeder Zeile ein Kasten und aus
     jeder Zelle eine Zeile mit ihrem Namen davor; ohne die Namen wäre das
     eine Folge von Werten ohne Bedeutung. Es gibt rund hundert `table.liste`
     in dieser Oberfläche - ein `data-spalte` von Hand wäre hundertmal
     dieselbe Angabe. Die Regel steht in `teile/tabellenbeschriftung.ts`,
     ohne JSX daneben, damit ein Prüfstand sie ausrechnen kann. */
  useEffect(() => {
    if (!buehne.current) return;
    return beobachteTabellen(buehne.current);
  }, [ich]);

  /* WIE HOCH DIE KOPFLEISTE IST, ENTSCHEIDET, WO DAS MENÜPANEL ANFÄNGT.
     Gemessen statt gesetzt - siehe `teile/klebeband.ts`. */
  useEffect(() => beobachteKopfleiste(), [ich]);
  // Auf welchem Reiter die Akte aufgeht. Siehe `oeffne` weiter unten.
  const [akteReiter, setAkteReiter] = useState<string>(start.reiter ?? 'uebersicht');
  /* Von welchem Bildschirm aus die Akte geöffnet wurde. Siehe `oeffne`. */
  const [herkunft, setHerkunft] = useState<string>('auftraege');
  /* DER PLATZ STEHT IN DER ADRESSE, sobald jemand angemeldet ist. Vorher
     nicht: die Anmeldemaske soll die Adresse, mit der jemand kam, stehen
     lassen, damit er nach der Anmeldung dort landet. */
  useEffect(() => {
    if (ich) inAdresse({ wo, akte, reiter: wo === 'akte' ? akteReiter : null, bereich });
  }, [ich, wo, akte, akteReiter, bereich]);
  /* DER QUICKLINK WIRD NACH DER ANMELDUNG AUFGELÖST (.332): #/a/<KLS-ID>
     fragt den Server nach dem Auftrag und öffnet die Akte. Gibt es ihn nicht
     (oder darf diese Firma ihn nicht sehen), bleibt die Liste, mit Hinweis. */
  const [quicklinkFehler, setQuicklinkFehler] = useState<string | null>(null);
  const [ne4Oeffne, setNe4Oeffne] = useState<string | null>(null);
  useEffect(() => {
    const k = start.kennung;
    if (!ich || !k) return;
    /* .557: DER NE4-LINK (#/a/ne4/<KLS-ID>) öffnet das Haus in den NE4-Aufträgen. */
    if (start.bereich === 'ne4') {
      api.ne4Auftraege(new URLSearchParams({ zustand: 'alle', suche: k })).then((r: any) => {
        const t = (r?.zeilen ?? []).find((z: any) => String(z.kls_id) === k) ?? (r?.zeilen ?? [])[0];
        if (t?.id) { setNe4Oeffne(t.id); setWo('ne4_auftraege'); }
        else setQuicklinkFehler(`Zu „${k}" gibt es keinen NE4-Auftrag.`);
      }).catch((f: any) => setQuicklinkFehler(f?.message ?? `Zu „${k}" gibt es keinen NE4-Auftrag.`));
      return;
    }
    api.auftragUeberKennung(k).then((r) => {
      const t = r?.treffer?.[0];
      if (t?.id) { setAkte(t.id); setAkteReiter('uebersicht'); setWo('akte'); }
      else setQuicklinkFehler(`Zu „${k}" gibt es keinen Auftrag.`);
    }).catch((f: any) => setQuicklinkFehler(f?.message ?? `Zu „${k}" gibt es keinen Auftrag.`));
  }, [ich]);
  /* UND WAS DIE ADRESSE VERLANGT, MUSS ES FÜR DIESEN ZUGANG GEBEN. Ein
     Partner, der eine Adresse „#/rechnungen" bekommt, landet in seinen
     Aufträgen und nicht vor einem leeren Bildschirm. */
  useEffect(() => {
    if (!bauplan.length) return;
    /* .597: die NE4-Übersicht gibt es nicht mehr; wer dort stand (alte Adresse), landet in den Aufträgen. */
    const erlaubt = new Set(bauplan.map((b) => b.schluessel).filter((k) => k !== 'ne4_start'));
    /* DER ERSTE MENÜPUNKT DES BEREICHS, nicht „auftraege": ein NE4-Zugang hat
       keine Auftragsliste, und ein Rückfall auf einen Bildschirm, den es für
       ihn nicht gibt, wäre die weisse Fläche von damals. */
    /* .595: DIE ARBEITSLISTE ZUERST, nicht der erste Punkt der Sortierung (das war das Handbuch).
       Marvin, 02.11.2026: „die sollen direkt immer, egal wer, bei Meine Aufträge sich einloggen. Und auch
       wenn wir reinjoinen." Firma und Team landen nach jeder Anmeldung in „Meine Aufträge". */
    const vorrang = ['ne4_firmenauftraege', 'auftraege', 'ne4_auftraege'].find((k) => bauplan.some((b) => b.schluessel === k && b.im_menue));
    const erster = vorrang ?? bauplan.find((b) => b.im_menue)?.schluessel ?? 'auftraege';
    const neuerZugang = ich?.benutzerId && zuletztZugang.current !== ich.benutzerId;
    if (ich?.benutzerId) zuletztZugang.current = ich.benutzerId;
    if (neuerZugang && erlaubt.has('ne4_firmenauftraege') && wo !== 'ne4_firmenauftraege') { setAkte(null); setWo('ne4_firmenauftraege'); return; }
    if (wo === 'akte' ? !akte : !erlaubt.has(wo)) { setAkte(null); setWo(erster); }
  }, [bauplan]);
  /* WO ICH WAR, ALS ICH IN JEMANDEN HINEINGEGANGEN BIN.
     ------------------------------------------------------------------------
     ORIGINALTEXT MARVIN (03.09.2026)
       „wenn ich mich «einlogge als» und dann wieder zurückgehe dann springt er
        auf die aufträge aber nicht zurück zu den benutzern und gruppen, wo ich
        zuletzt war. passe das an."

     ES IST DIESELBE REGEL WIE BEIM „← Liste" DER AKTE: **ein Rückweg führt
     dorthin, wo man herkam.** Wer aus „Benutzer und Rechte" in einen Zugang
     geht, will danach die Zeile wieder vor sich haben, an der er stand - und
     nicht zwei Klicks weit weg auf der Arbeitsliste stehen.

     Ohne Wert heisst „Arbeitsliste": nach einem Neuladen der Seite weiss
     niemand mehr, wo jemand vorher war, und ein geratener Ort wäre schlimmer
     als der bekannte Anfang. */
  const [vorUebernahme, setVorUebernahme] = useState<string | null>(null);
  const [meineAnmeldung, setMeineAnmeldung] = useState(false);
  /* WANN DAS EIGENE BILD ZULETZT GEWECHSELT HAT. Der Leseweg gibt eine Stunde
     Zwischenspeicher mit - ohne einen neuen Wert in der Adresse zeigt der
     Kreis nach dem Hochladen weiter das alte Bild, und wer es gerade
     ausgetauscht hat, hält den Weg für kaputt. */
  const [bildStempel, setBildStempel] = useState(() => Date.now());
  /* DIE ZÄHLER DER ARBEITSLISTE STANDEN NUR FÜR DIE ZAHL AM MENÜPUNKT HIER,
     und die gibt es seit .88 nicht mehr. Der Weg von der Liste hierher fällt
     damit weg - eine Angabe, die niemand mehr liest, ist eine Angabe, die
     beim nächsten Umbau falsch wird und es niemandem sagt. */
  // Wie viele Dateien im Posteingang liegen geblieben sind. Siehe unten, warum
  // daran der ganze Menuepunkt haengt.
  const [liegt, setLiegt] = useState(0);
  // Nach dem Passwort kann zweierlei anstehen: den Code eingeben, oder den
  // Faktor ueberhaupt erst einrichten. Beides gehoert vor die Anwendung.
  /* DREI LAGEN UND NICHT ZWEI, und die dritte ist seit .149 dazugekommen.
     `code` = die halbe Anmeldung, der Faktor steht und der Code fehlt.
     `pflicht` = seine Gruppe verlangt einen, und er hat keinen. Er darf NICHT
        abbrechen, denn der Server weist ohnehin jeden Datenweg ab - **ein
        Abbrechen-Knopf, hinter dem nichts geht, ist schlimmer als keiner.**
     EINEN DRITTEN GAB ES BIS .148 (`einrichten`, mit dem Knopf „Später"), und
     er ist gefallen: gesetzt wurde er nur nach dem Anmelden, und dort heisst
     die Antwort des Servers PFLICHT. Die freiwillige Einrichtung steht unter
     „Meine Anmeldung" und braucht diesen Zustand nicht. */
  const [faktorNoetig, setFaktorNoetig] =
    useState<'code' | 'pflicht' | null>(null);
  /* DIE WEGE NACH DRAUSSEN. Marvin, 27.08.2026: „Ich will auch gerne den Link
     zur Telekom als externen Link mit rein zu nehmen." Sie kommen aus einer
     eigenen Tabelle und nicht aus `modul`: ein Modul ist ein Bildschirm, den
     die Oberfläche an seinem Schlüssel erkennt, ein Link ist eine Adresse. */
  const [links, setLinks] = useState<any[]>([]);

  /* UND OB DIE GRUPPE „Externe Links" AUFGEKLAPPT IST.
   *
   * DER HAKEN STEHT HIER OBEN, wo er JEDEN Durchgang erreicht - darunter
   * liegen sechs bedingte `return` (Anmeldung, zweiter Faktor, Warteseite),
   * und ein Haken dahinter läuft in manchen Durchgängen und in anderen nicht.
   * React beendet das mit einem weissen Bildschirm. Dieselbe Zeile wie beim
   * Burger darunter. */
  const [externOffen, setExternOffen] = useState(false);

  /* DAS MENÜ IST AUF DEM TELEFON EIN BURGER.
   *
   * ORIGINALTEXT MARVIN (05.09.2026, mit zwei Bildschirmfotos vom iPhone)
   *   „es sind menüs nicht erkennbar ... für das menü unten zb empfehle ich
   *    einen «burger» oben einzubauen."
   *
   * **ER HAT RECHT, UND ES WAR NACHZUMESSEN: die Menüleiste am unteren Rand
   * ist 1626 Bildpunkte breit, das Fenster 375.** Fünf von neunzehn
   * Menüpunkten standen im Bild; die übrigen vierzehn lagen dahinter und
   * waren nur durch seitliches Wischen zu erreichen - ohne dass irgendetwas
   * gesagt hätte, dass da noch etwas kommt. **Eine Leiste, die man wischen
   * muss und die es nicht sagt, ist von einer abgeschnittenen nicht zu
   * unterscheiden.**
   *
   * DER ZUSTAND STEHT HIER OBEN UND NICHT IN DER LEISTE, und er steht bei den
   * ÜBRIGEN HAKEN und nicht weiter unten: darunter liegen sechs bedingte
   * `return` (Anmeldung, zweiter Faktor, Warteseite). Ein Haken dahinter
   * läuft in manchen Durchgängen und in anderen nicht - React beendet das mit
   * „Rendered more hooks than during the previous render", also einem weissen
   * Bildschirm. **Ein Haken gehört an den Anfang, wo er JEDEN Durchgang
   * erreicht.** */
  const [menueOffen, setMenueOffen] = useState(false);

  /* ESCAPE SCHLIESST ES AUCH. Ein Panel, das den halben Bildschirm einnimmt
     und nur über einen Knopf zugeht, ist auf einem Telefon eine Falle: der
     Daumen liegt unten, der Knopf steht oben. Deshalb schliesst zusätzlich
     ein Tippen auf die Fläche daneben. */
  useEffect(() => {
    if (!menueOffen) return;
    const zu = (e: KeyboardEvent) => { if (e.key === 'Escape') setMenueOffen(false); };
    window.addEventListener('keydown', zu);
    return () => window.removeEventListener('keydown', zu);
  }, [menueOffen]);

  /**
   * Wer bin ich, und welche Bildschirme habe ich.
   *
   * ERST „ICH", DANN DER REST - und nicht beides zusammen.
   *
   * Hier stand `Promise.all([api.ich(), api.bauplan()])`, und das war falsch,
   * sobald eine Anmeldung UNVOLLSTAENDIG ist: wer den zweiten Faktor noch
   * offen hat oder ein geliehenes Passwort wechseln muss, darf `/api/ich`
   * abrufen und sonst NICHTS. `api.bauplan()` bekam 401, `Promise.all` warf,
   * und der Auffangzweig setzte `ich` auf null - der Benutzer sah die
   * ANMELDEMASKE, obwohl er richtig angemeldet war. Er tippt sein Passwort
   * ein, kommt herein, sieht wieder die Anmeldemaske. Aufgefallen ist es an
   * einem Bildschirmfoto des Wechselzwangs; beim Faktorriegel steckte
   * derselbe Fehler seit Migration 042 und ist nie aufgefallen, weil man
   * dort auf einer bereits geladenen Seite landet und nicht neu laedt.
   *
   * WER NOCH NICHT DURCH IST, BEKOMMT KEIN MENUE - er braucht auch keins:
   * der naechste Bildschirm ist der Code oder das neue Passwort.
   *
   * UND WER DURCH IST, BEKOMMT BEIDES ZUSAMMEN. Das Menue haengt an den
   * Rechten des Angemeldeten; wer nur „ich" neu laedt und den Bauplan nicht,
   * sitzt vor einer leeren Seitenleiste, und das sieht aus wie eine kaputte
   * Oberflaeche.
   */
  async function anmelderUndMenue() {
    try {
      const i = await api.ich();
      /* WER NOCH NICHT DURCH IST, BEKOMMT KEIN MENUE - und wer WARTET, auch
         nicht. `api.bauplan()` bekaeme fuer ihn ein 403, `anmelderUndMenue`
         liefe in den Auffangzweig und setzte `ich` auf null: der Wartende
         saehe die ANMELDEMASKE, tippte sein richtiges Passwort ein und
         landete wieder dort. Genau dieser Fehler ist am 27.08.2026 beim
         Wechselzwang aufgefallen; er waere hier zum dritten Mal derselbe. */
      /* UND WER SEINEN FAKTOR ERST EINRICHTEN MUSS, AUCH NICHT. Seit .149 ist
         die 2FA-Pflicht ein Riegel im Server und keine Aufforderung mehr;
         `api.bauplan()` bekommt fuer ihn ein 403, `anmelderUndMenue` liefe in
         den Auffangzweig und setzte `ich` auf null - er saehe die
         ANMELDEMASKE, tippte sein richtiges Passwort ein und landete wieder
         dort. Vierter Fall derselben Sache nach Faktor, Wechselzwang und
         Warteseite. */
      if (i.faktorOffen || i.passwortWechseln || i.wartet
          || i.faktorEinrichtenNoetig) {
        setIch(i); setBauplan([]); setLinks([]);
        return;
      }
      /* WELCHER BEREICH GILT: der gewählte, wenn dieser Zugang ihn hat, sonst
         sein erster. Ohne Bereiche (kein Zugang hat eine Gruppe) kommt alles,
         was er darf, wie bisher. */
      const meine = (i.bereiche ?? []).map((x) => x.schluessel);
      const gewaehlt = bereich && meine.includes(bereich) ? bereich : (meine[0] ?? null);
      if (gewaehlt !== bereich) setBereich(gewaehlt);
      try { if (gewaehlt) localStorage.setItem('mds.bereich', gewaehlt); } catch { /* ohne Speicher gilt die Adresse */ }
      const b = await api.bauplan(gewaehlt);
      setIch(i); setBauplan(b.module);
      api.links().then(setLinks).catch(() => setLinks([]));
      /* WAS EINER SELBST GESETZT HAT, GILT; SONST ENTSCHEIDET, WER ER IST.
         Ein Partner hat ein oder zwei Links und braucht sie - für ihn steht
         die Gruppe offen. Der Innendienst hat ein langes Menü, und für ihn
         steht sie zu. */
      const gemerkt = (i as any).ansicht?.menue?.extern;
      setExternOffen(typeof gemerkt === 'boolean' ? gemerkt : !!i.istSub);
      // Der Posteingang meldet sich nur, wenn er etwas will.
      if ((i.rechte ?? []).includes('eingang.lesen')) {
        api.eingang('offen')
          .then((e) => setLiegt(e?.zahlen?.offen ?? 0))
          .catch(() => setLiegt(0));
      }
    } catch (f: any) {
      /* EIN 401 MIT `faktorOffen` IST KEINE ABGELAUFENE ANMELDUNG.
       *
       * Er heisst: das Passwort hat gestimmt, der Code fehlt. Wer ihn wie
       * jeden anderen 401 behandelt, setzt `ich` auf null und zeigt die
       * ANMELDEMASKE - und genau das stand am 09.09.2026 auf Marvins
       * Bildschirmfoto, mit dem Riegeltext als rotem Kasten darueber.
       *
       * Behoben ist die Ursache im Server (`/api/ich` darf durch, und die
       * Antwort ist dann schmal). Diese Zeile ist der Riegel dagegen, dass
       * derselbe Fehler beim naechsten vergessenen Weg wiederkommt:
       * **eine halbe Anmeldung fuehrt zur Codeseite und nie zur
       * Anmeldemaske.** */
      if (f?.daten?.faktorOffen) {
        setFaktorNoetig('code'); setBauplan([]); setLinks([]);
      } else if (f?.daten?.faktorEinrichtenNoetig) {
        /* EIN 403 MIT `faktorEinrichtenNoetig` IST AUCH KEINE ABGELAUFENE
           ANMELDUNG. Er heisst: das Passwort hat gestimmt, die Gruppe verlangt
           einen zweiten Faktor, und dieser Zugang hat keinen. Dieselbe Zeile
           wie darueber und aus demselben Grund - **eine Pflicht fuehrt zur
           Einrichtungsseite und nie zur Anmeldemaske.** */
        setFaktorNoetig('pflicht'); setBauplan([]); setLinks([]);
      } else {
        setIch(null); setBauplan([]); setLinks([]);
      }
    } finally {
      setLaedt(false);
    }
  }

  useEffect(() => { anmelderUndMenue(); }, []);
  /* .583: Marvin, 02.11.2026: „wenn ich Rechte zuweise ... dann muss das
     sofort gepusht werden." Der Puls meldet einen geänderten Zugang, hier
     kommen Menü und Rechte neu, die Seite bleibt stehen. */
  useEffect(() => {
    const neu = () => { void anmelderUndMenue(); };
    window.addEventListener('mds-zugang', neu);
    return () => window.removeEventListener('mds-zugang', neu);
  }, [bereich]);

  /* DER EINZIGE WEG, AUF DEM DIESE ANWENDUNG EINE ADRESSZEILE LIEST.
   *
   * Marvin, 27.08.2026: „wenn ich einem neuen benutzer anlege dann soll er
   * eine email erhalten, wo ein link drin ist, wo er sein passwort setzen
   * muss."
   *
   * Sonst hat dieses Programm keine Adressen: es ist EIN Bildschirm, und was
   * darauf steht, entscheidet der Zustand und nicht die Adresszeile. Hier
   * geht es nicht anders - der Link kommt aus einer Mail und muss irgendwo
   * ankommen.
   *
   * ER FUEHRT NICHT IN DIE ANWENDUNG. Nach dem Setzen des Passworts wird die
   * Adresse auf „/" zurueckgesetzt und die Anmeldung gezeigt: der Weg herein
   * bleibt Mailadresse und Passwort. */
  const einladung = /^\/einladung\/([A-Za-z0-9_-]{20,})$/
    .exec(window.location.pathname)?.[1];
  if (einladung) {
    return (
      <Einladung
        token={einladung}
        fertig={() => {
          window.history.replaceState(null, '', '/');
          anmelderUndMenue();
        }}
      />
    );
  }

  /* EIN LINK AUF #/akte/<id> ÖFFNET DIE AKTE (.476). Marvin, 23.10.2026,
     Abrechnung, Zahlung: „er springt nicht zum Auftrag". Die Adresse wurde
     nur beim Laden gelesen. Die Oberfläche schreibt selbst mit replaceState,
     das löst kein hashchange aus; jeder hashchange kommt also von einem Link.
     WEISSE SEITE NACH .476/.477 (.478): dieser Hook stand hinter
     `if (laedt) return null`. React zählt die Hooks je Zeichnen; nach dem
     Laden war es einer mehr, und der ganze Baum fiel weg. Er steht jetzt hier,
     vor jedem return, und ruft nur die Funktion, die unten gesetzt wird. */
  useEffect(() => {
    const folgen = () => hashFolger.current();
    window.addEventListener('hashchange', folgen);
    return () => window.removeEventListener('hashchange', folgen);
  }, []);
  if (laedt) return null;

  /* DIE CODESEITE STEHT VOR DER ANMELDEMASKE, und die Reihenfolge ist die
   * ganze Behebung vom 09.09.2026.
   *
   * Sie stand darunter, und `ich` ist bei einer halben Anmeldung genau dann
   * null, wenn der Server auf `/api/ich` mit 401 antwortet. Dann gewann
   * `if (!ich)`, und der Benutzer sah die Maske, deren Absenden der Riegel
   * gerade abweist - **eine Anmeldemaske als Antwort auf „der Code fehlt
   * noch" schickt jeden in einen Kreis.**
   *
   * Der Riegel selbst sitzt im Server; das hier ist nur die Anzeige dazu.
   * Wer diesen Bildschirm wegklickt, kommt an keine einzige Zahl heran. */
  if (faktorNoetig === 'code' || ich?.faktorOffen) {
    return (
      <FaktorAbfrage fertig={() => { setFaktorNoetig(null); anmelderUndMenue(); }} />
    );
  }

  if (!ich) {
    return (
      <Anmeldung
        fertig={(a) => {
          if (a?.faktorOffen) { setFaktorNoetig('code'); return; }
          /* `faktorEinrichten` IST DIE PFLICHT UND NICHT EIN ANGEBOT. Der
             Server rechnet es als `brauchtFaktor && !hatFaktor`, und
             `brauchtFaktor` ist `pflichtFuer(id)` - er schickt es also genau
             dann, wenn die Gruppe einen zweiten Faktor verlangt. Hier stand
             bis .148 `'einrichten'`, und dieser Zustand zeichnet die
             Einrichtung MIT dem Knopf „Später". Damit war die Pflicht eine
             Aufforderung: wer ihn drückte, arbeitete weiter.
             GEFUNDEN HAT ES DER BROWSER-PRÜFSTAND 021 UND KEIN NACHDENKEN.
             Über HTTP war alles richtig - der Server wies jeden Datenweg mit
             403 ab. Nur zeichnete die Oberfläche daneben einen Knopf, hinter
             dem nichts mehr geht. */
          if (a?.faktorEinrichten) { setFaktorNoetig('pflicht'); }
          anmelderUndMenue();
        }}
      />
    );
  }
  /* HIER STAND EIN BLOCK `faktorNoetig === 'einrichten'` MIT EINEM KNOPF
     „Später", UND ER IST AM 09.09.2026 GEFALLEN. Gesetzt wurde der Zustand an
     genau einer Stelle - nach dem Anmelden, wenn der Server `faktorEinrichten`
     schickt -, und das ist die PFLICHT und kein Angebot. Toten Code entfernen,
     nicht auskommentieren: ein Zustand, den nichts mehr setzt, wird beim
     nächsten Umbau wieder gesetzt, und dann ist die Pflicht wieder eine
     Aufforderung. Die FREIWILLIGE Einrichtung steht weiterhin unter „Meine
     Anmeldung" (`MeineSicherheit` in `Faktor.tsx`), und dort gehört sie hin:
     wer sie sucht, hat ein Menü. */

  /* DAS GELIEHENE PASSWORT, UND ZWAR NACH DEM ZWEITEN FAKTOR.
   *
   * Wer den Faktor noch offen hat, ist nicht fertig angemeldet; ein
   * Passwortwechsel mitten in einer halben Anmeldung wäre ein zweiter Riegel
   * in einem ersten. Deshalb steht dieser Block unter den beiden
   * Faktorblöcken - und der Server hält dieselbe Reihenfolge ein.
   *
   * Der Riegel selbst sitzt dort (`OHNE_WECHSEL_ERLAUBT` in `server.ts`);
   * das hier ist nur die Anzeige dazu. */
  if (ich.passwortWechseln) {
    return (
      <PasswortWechsel name={ich.echterName ?? ich.name}
                       fertig={anmelderUndMenue} />
    );
  }

  /* DER ZUGANG, DER NOCH WARTET - und zwar ZULETZT von den drei Riegeln.
   *
   * ORIGINALTEXT MARVIN (03.09.2026)
   *   „ich will gerne, dass sich die Auftragnehmer regisrieren, aber sie noch
   *    nichts aktiv sehen oder bedienen können."
   *
   * Die Reihenfolge ist dieselbe wie im Server: erst der zweite Faktor (die
   * Anmeldung ist sonst gar nicht fertig), dann das geliehene Passwort, dann
   * die Freischaltung. Wer auf der Warteseite sein Passwort setzt, hat den
   * Wechselzwang naemlich schon hinter sich - andersherum saehe er die
   * Warteseite und koennte darauf nichts tun, weil der Server jeden Weg
   * ausser dem Wechsel abweist.
   *
   * DER RIEGEL SITZT IM SERVER (`OHNE_FREISCHALTUNG_ERLAUBT`); das hier ist
   * nur die Anzeige dazu. Wer dieses Fenster wegraeumt, kommt trotzdem an
   * keine einzige Zahl heran. */
  if (ich.wartet) {
    return (
      <Warteseite
        ich={ich}
        abmelden={() => api.abmelden().then(() => setIch(null))}
        neuLaden={anmelderUndMenue}
        zurueckZuMir={ich.echterBenutzerId ? () => api.zurueckZuMir().then(() => {
          anmelderUndMenue();
          setAkte(null); setWo(vorUebernahme ?? 'auftraege');
          setVorUebernahme(null);
        }) : undefined}
      />
    );
  }

  /* DIE 2FA-PFLICHT - und zwar ZULETZT von allen vier Riegeln, wie im Server.
   *
   * ORIGINALTEXT MARVIN (08.09.2026)
   *   „2FA: in Einstellungen aktiviert, aber nicht bei Gruppen/Benutzern
   *    sichtbar; sicherheitsrelevante Änderung muss Sitzungen beenden und beim
   *    nächsten Login greifen (wie abgelaufenes Passwort)"
   *
   * DIE REIHENFOLGE IST DIESELBE WIE IM SERVER: erst der Code (die Anmeldung
   * ist sonst gar nicht fertig), dann das geliehene Passwort, dann die
   * Freischaltung, dann die Pflicht. Wer noch wartet, richtet seinen Faktor
   * auf der Warteseite ein - stuende dieser Block davor, saehe er die
   * Einrichtungsseite, und der Server wiese jeden Weg darauf mit dem
   * WARTETEXT ab. `GET /ich` haelt dieselbe Reihenfolge ein.
   *
   * UND HIER GIBT ES KEIN ABBRECHEN. Der Block weiter oben ist die
   * FREIWILLIGE Einrichtung, und dort gehoert der Knopf hin. Hier weist der
   * Server jeden Datenweg mit 403 ab: ein Abbrechen fuehrte auf einen
   * Bildschirm, auf dem jede Kachel leer bliebe, und das sieht aus wie eine
   * kaputte Anwendung. Bis .148 war genau dieser Knopf da - und damit war die
   * Pflicht eine Aufforderung und kein Riegel.
   *
   * DER RIEGEL SITZT IM SERVER (`OHNE_EINRICHTUNG_ERLAUBT`); das hier ist nur
   * die Anzeige dazu. Wer dieses Fenster wegraeumt, kommt an keine einzige
   * Zahl heran. */
  if (faktorNoetig === 'pflicht' || ich.faktorEinrichtenNoetig) {
    return (
      <div className="anmeldeseite">
        <div style={{ maxWidth: 760, width: '100%' }}>
          <div className="hinweis" style={{ marginBottom: 12 }}>
            <b>Für diesen Zugang ist ein zweiter Faktor Pflicht.</b>
            <div className="klein" style={{ marginTop: 4 }}>
              Bitte jetzt eine Authenticator-App oder einen Passkey einrichten.
              Danach geht es normal weiter.
            </div>
          </div>
          <FaktorEinrichtung
            fertig={() => { setFaktorNoetig(null); anmelderUndMenue(); }}
          />
          {/* KEINE SACKGASSE (.213).
              Marvin, 23.09.2026: „ich komme nicht mehr da raus. ich nicht
              abbrechen oder zurück in meinen zugang. auch das neue öffnen der
              seite hat nicht geholfen. baue entsprechende button ein für mich"
              Beide Wege stehen im Server auf `OHNE_EINRICHTUNG_ERLAUBT`. Ein
              Abbrechen INS PROGRAMM gibt es weiter nicht: das wäre ein Loch
              im Riegel. Hinaus geht es immer. */}
          <div className="knopfreihe faktor-ausweg" style={{ marginTop: 12 }}>
            {ich.echterBenutzerId && (
              <button className="knopf haupt" onClick={() => api.zurueckZuMir().then(() => {
                setFaktorNoetig(null);
                anmelderUndMenue();
                setAkte(null); setWo(vorUebernahme ?? 'auftraege'); /* gehZu steht erst weiter unten */
                setVorUebernahme(null);
              })}>
                Zurück zu mir{ich.echterName ? ` (${ich.echterName})` : ''}
              </button>
            )}
            <button className="knopf" onClick={() => api.abmelden().then(() => {
              setFaktorNoetig(null); setIch(null);
            })}>
              Abmelden
            </button>
          </div>
        </div>
      </div>
    );
  }

  /* EINE AKTE LAESST SICH AUF EINEM BESTIMMTEN REITER OEFFNEN.
   *
   * ORIGINALTEXT MARVIN (25.08.2026)
   *   „mir fehlt allgemein die saubere struktur wie vorher mit den einzelnen
   *    menüs wo ich was anklicken und ausführen kann. ich habe den eindruck
   *    als ist die ganze zeit derzeit sehr ,nur anschauen aber nicht
   *    bearbeiten' lastig."
   *
   * Er hat recht, und die Ursache ist genau hier: die Uebersichtsbildschirme
   * aus dem Menue konnten eine Akte nur AUFMACHEN. Wer in der Behoerdenmappe
   * eine Baustelle ohne Anordnung sah, landete auf der Uebersicht und musste
   * den Reiter „Behoerde" selbst suchen. Fuenf Zeilen abarbeiten hiess
   * fuenfmal denselben Umweg.
   *
   * Jetzt sagt der Rufer, WOHIN. Damit wird aus jeder Uebersichtszeile ein
   * Weg zu dem Handgriff, den sie meldet. */
  /* UND „ZURÜCK" FÜHRT DORTHIN, WO MAN HERKAM.
   *
   * ORIGINALTEXT MARVIN (31.08.2026)
   *   „wenn ich aber aus der terminliste komme, dann soll er dahin zurück
   *    gehen, also immer wo er herkam. sonst musst du wieder extra klicks
   *    machen."
   *
   * Der Rückweg stand fest auf „auftraege". Wer aus dem Terminplan eine Akte
   * öffnet, landete danach in der Auftragsliste - und musste sich seinen
   * Termin wieder heraussuchen: Menüpunkt, Woche, Tag. Bei zehn Terminen an
   * einem Vormittag sind das dreissig Handgriffe, die niemand bestellt hat.
   *
   * GEMERKT WIRD NUR DER ERSTE SPRUNG. Öffnet die Akte selbst eine zweite
   * Akte (über die Glocke, über einen Doppelgänger), bleibt die HERKUNFT
   * stehen: sonst zeigt „zurück" auf die Akte, aus der man gerade kam, und
   * man klettert rückwärts durch die eigene Spur statt herauszukommen. */
  const oeffne = (id: string, reiter?: string) => {
    /* DIE STELLE MERKEN (.479). Marvin, 23.10.2026: „wenn ich in einen Auftrag reinspringe und
       springe dann wieder zurück, dann fange ich wieder von vorne an." Gemerkt wird, wie weit die
       Bühne gerollt war; „zurück" stellt das wieder her. */
    if (wo !== 'akte') { try { rollMerk.current[wo] = rollbereich().lies(); } catch { /* egal */ } }
    if (wo !== 'akte') setHerkunft(wo);
    setAkte(id); setAkteReiter(reiter ?? 'uebersicht'); setWo('akte');
  };
  const gehZu = (s: string) => { setAkte(null); setWo(s); setMenueOffen(false); };
  /* DER WEG HINTER DEM # (.476, .478): was ein Wechsel tut, steht hier, wo
     oeffne und gehZu bekannt sind. Gehört wird oben, VOR dem ersten return:
     ein Hook hinter einem frühen return bringt React beim Wechsel zwischen
     „lädt“ und „geladen“ zum Absturz, und die Seite bleibt weiß. */
  hashFolger.current = () => {
    /* Nur Wege (#/...), keine Sprungmarken auf der Seite (#vorschlaege im Material). */
    if (!window.location.hash.startsWith('#/')) return;
    const s = ausAdresse();
    if (s.wo === 'akte' && s.akte) { if (s.akte !== akte || wo !== 'akte') oeffne(s.akte, s.reiter ?? undefined); }
    else if (s.wo && s.wo !== wo && !s.kennung) gehZu(s.wo);
  };
  /* DEN BEREICH WECHSELN: anderes Menü, anderer erster Bildschirm, andere
     Farbe. Die Daten dahinter trennt der Server; hier wechselt nur die Sicht. */
  async function bereichWechseln(neu: string) {
    if (neu === bereich) return;
    setBereich(neu);
    try { localStorage.setItem('mds.bereich', neu); } catch { /* siehe oben */ }
    try {
      const b = await api.bauplan(neu);
      setBauplan(b.module);
      /* .544: die externen Links gelten je Bereich. */
      api.links().then(setLinks).catch(() => setLinks([]));
      setAkte(null); setMenueOffen(false);
      /* DER BEREICH FÄNGT AUF SEINER ÜBERSICHT AN (.400). Marvin, 19.10.2026:
         „wenn ich von ne3 in ne4 gehe dann startet er immer im Adressbuch
         als im Bereich Übersicht." Das erste Modul im Menü war das Adressbuch
         (Reihenfolge 4, gemeinsam für beide Bereiche). Gibt es `<bereich>_start`,
         ist das der Anfang; sonst das erste Modul, das nur diesem Bereich gehört;
         sonst das erste im Menü. */
      /* .597: KEINE ÜBERSICHT MEHR, DER BEREICH FÄNGT BEI DEN AUFTRÄGEN AN. Marvin, 02.11.2026:
         „gibt es keine Übersichtsseite mehr. Wir starten bei den Aufträgen. Wie ich jetzt von NE3 auf NE4
         gewechselt habe, bringt er mir wieder diese Übersichtsseite ... Kannst du direkt komplett entfernen."
         Dieselbe Reihenfolge wie nach der Anmeldung: Meine Aufträge, Aufträge, NE4-Aufträge. */
      const imMenue = (k: string) => b.module.some((m) => m.schluessel === k && m.im_menue);
      const start = ['ne4_firmenauftraege', 'auftraege', 'ne4_auftraege'].find(imMenue)
        ?? b.module.find((m) => m.im_menue && m.schluessel.startsWith(`${neu}_`) && m.schluessel !== `${neu}_start`)?.schluessel
        ?? b.module.find((m) => m.im_menue)?.schluessel;
      setWo(start ?? (neu === 'ne3' ? 'auftraege' : `${neu}_auftraege`));
    } catch { /* der Server sagt es beim nächsten Weg */ }
  }
  const bereichJetzt = (ich?.bereiche ?? []).find((b) => b.schluessel === bereich) ?? null;

  /* WAS DIESE LISTE IST, UND WAS SIE NICHT MEHR IST.
   *
   * `/bauplan` liefert die Module, auf die dieser Benutzer mindestens ein
   * Recht hat. Daraus entsteht das Menue, und nur daraus.
   *
   * DER BILDSCHIRM „BAUPLAN" IST WEG (Marvin, 25.08.2026: „unten kategorie
   * umbau kommt raus"). Er hat den Baufortschritt des Umbaus gezeigt, also
   * eine Frage der Entwicklung und nicht des Betriebs.
   *
   * UND SEIT MIGRATION 102 IST AUCH DIE SPALTE `stand` FORT. Hier stand, sie
   * bleibe in der Datenbank, weil `/api/version` und die Lieferdisziplin
   * daran haengen - das stimmte, solange es Bildschirme gab, die noch nicht
   * fertig waren. Seit dem 28.08.2026 stehen alle zweiundzwanzig auf
   * „fertig": ein Filter, der nie etwas herausnimmt, und ein Punkt, der nie
   * erscheint. Was ein Menuepunkt zeigt, entscheidet jetzt allein `im_menue`
   * und das Recht dahinter.
   */
  const sichtbar = bauplan.filter((b) => b.im_menue);
  /* HIER STAND `.filter((g) => g !== 'Umbau')`.
     Die Menügruppe „Umbau" trug ein einziges Modul, den Bauplan - die
     Fortschrittsanzeige des Umbaus. Marvin am 01.09.2026: „den ganzen punkt
     Umbau/Bauplan ist überflüssig und kann vollständig aus dem system
     gelöscht werden." Mit Migration 092 gibt es das Modul nicht mehr, und
     eine Gruppe entsteht in diesem System aus ihren Modulen: sie fällt von
     selbst weg. **Ein Filter auf einen Namen, den es nicht mehr gibt, ist
     ein Riegel gegen ein Gespenst** - und beim nächsten Nachtrag fragt sich
     jemand, warum eine Gruppe dieses Namens nicht erscheinen darf. */
  /* DIE GRUPPEN DES GEWÄHLTEN BEREICHS STEHEN VORN (.333): in NE4 kommt
     „NE4" vor der Verwaltung, in NE3 ändert sich nichts. Die gemeinsamen
     Gruppen (Verwaltung, System, Hilfe) stehen dahinter in ihrer Reihenfolge. */
  const nurHier = (g: string) => sichtbar.some((b) => b.gruppe === g && b.bereiche && !b.bereiche.includes('ne3'));
  const gruppen = [...new Set(sichtbar.map((b) => b.gruppe))]
    .sort((x, y) => Number(nurHier(y)) - Number(nurHier(x)));
  return (
    <div className={'gerüst' + (menueOffen ? ' menueoffen' : '')}
         data-bereich={bereich ?? 'ne3'}
         style={bereichJetzt && bereich !== 'ne3' ? { ['--bereich-farbe' as any]: bereichJetzt.farbe } : undefined}>
      {/* DER KOPF STEHT EINMAL IM HAUS, UND ZWAR ALS EIGENES ELEMENT.
       *
       * Er trug bis .116 die Klasse `marke` und lag IM Seitenmenü. Auf dem
       * Telefon ist das Seitenmenü aber zugeklappt - und damit wären die
       * Wortmarke und vor allem DIE GLOCKE hinter einem Knopf verschwunden,
       * den man erst drücken muss, um zu sehen, dass etwas anliegt.
       *
       * **ZWEI GLOCKEN WÄREN DIE NAHELIEGENDE ANTWORT UND DIE FALSCHE:** sie
       * fragen beide, sie zählen beide, und beim ersten Nachtrag zeigt die
       * eine etwas anderes als die andere. Es gibt genau eine, sie steht
       * hier, und das Raster setzt den Kopf auf dem Schreibtisch an dieselbe
       * Stelle wie vorher - über das Seitenmenü, 236 Pixel breit. */}
      <header className="kopfleiste">
        {/* DER BURGER GIBT ES NUR AUF SCHMALEN BILDSCHIRMEN (CSS). Er trägt
            `aria-expanded`, damit ein Vorleseprogramm sagt, ob offen oder zu -
            ein Knopf, dessen Zustand nur die Farbe kennt, ist für den, der
            ihn nicht sieht, gar keiner. */}
        <button
          type="button"
          className="burger"
          aria-expanded={menueOffen}
          aria-controls="hauptmenue"
          aria-label={menueOffen ? 'Menü schließen' : 'Menü öffnen'}
          onClick={() => setMenueOffen(!menueOffen)}
        >
          <span aria-hidden="true">{menueOffen ? '✕' : '☰'}</span>
        </button>
        {/* DIE GLOCKE STEHT IM MARKENBLOCK UND NICHT DANEBEN.
         *
         * ORIGINALTEXT MARVIN (06.09.2026, mit einem Bild von .117 und einem
         * von .115 daneben)
         *   „hier had sich das menüband verschoben, oben die glocke mit der
         *    notifikation ist abgeschnitten, schaue dir die vorherigen
         *    versionen an und baue es wieder wie es war."
         *
         * ER HAT RECHT, UND ES WAR NACHZUMESSEN. Bis .116 lag die Glocke IN
         * `.marke`, und `margin-left: auto` schob sie an dessen rechten Rand;
         * der Markenblock war so breit wie die Seitenleiste. Mit der neuen
         * `.kopfleiste` standen Burger, Marke, ein `.wachsen`-Abstandhalter
         * und die Glocke NEBENEINANDER - **und `.wachsen` traegt `flex: 1`,
         * genau wie `.marke`.** Beide haben sich den freien Platz geteilt:
         *
         *     Seitenleiste   236 Bildpunkte
         *     .marke         109      davon .wer nur 32
         *     .wachsen        77      ein Abstandhalter, der nichts abstuetzt
         *     .glocke         36
         *
         * Bei 32 Bildpunkten bricht „MDS FTTH" auf ZWEI Zeilen, der Kopf wird
         * 85 statt 66 Bildpunkte hoch, und die Zahl an der Glocke rutscht
         * dabei ueber das gezeichnete Symbol. **Ein Abstandhalter, der neben
         * etwas steht, das selbst wachsen will, ist kein Abstand, sondern ein
         * zweiter Anspruch auf denselben Platz.**
         *
         * Sie steht deshalb wieder da, wo sie bis .116 stand. Der Burger
         * bleibt daneben - auf breiten Bildschirmen ist er `display: none`,
         * und dort war er nie das Problem. */}
        <div className="marke">
          <Marke />
          <div className="wer">
            {/* DER KOPF HEISST, WIE ER IMMER HIESS (.335). Marvin, 08.10.2026:
                „Oben links aus dem Menü kommt da Bereichsauswahl raus. Da
                kommen wieder die ursprünglichen Namen rein." Der Umschalter
                steht unten bei der Version. */}
            <b>MDS FTTH</b>
            <span>Auftragsverwaltung</span>
          </div>
          {/* Nicht in den Seitenkopf: der gehört dem Bildschirm und trägt
              dort Suchfeld, Zeitraum oder Werkzeuge. Eine Glocke, die je
              nach Seite woanders sitzt, wird gesucht statt gesehen.
              Marvin, 25.08.2026: „sollen wir eine notification glocke oben
              noch einbinden mit den infos und die man dann als gelesen
              markieren muss?" */}
          <Glocke ich={ich} oeffne={oeffne} gehZu={gehZu} bereich={bereich ?? 'ne3'} wo={wo} />
        </div>
      </header>

      {/* DIE FLÄCHE NEBEN DEM OFFENEN MENÜ SCHLIESST ES.
          Sie gibt es nur, solange es offen ist: ein durchsichtiger Kasten
          über dem ganzen Bildschirm fängt sonst jeden Klick ab, und der
          Fehler steht danach an einer Stelle, an der nichts kaputt ist. */}
      {menueOffen && (
        <div className="menueschatten" onClick={() => setMenueOffen(false)}
             aria-hidden="true" />
      )}

      <aside className="seitenleiste" id="hauptmenue">
        <nav className="navi">
          {sichtbar.length === 0 && (
            <p className="klein leise" style={{ padding: '0 14px' }}>
              Für dich ist noch kein Modul freigegeben. Der Innendienst kann das
              unter "Benutzer und Rechte" ändern.
            </p>
          )}
          {gruppen.map((g) => (
            <div key={g}>
              <h4>{g}</h4>
              {sichtbar
                /* DER POSTEINGANG STEHT NUR DA, WENN ETWAS LIEGT.
                 *
                 * ORIGINALTEXT MARVIN (24.08.2026)
                 *   „er soll die dateien im hintergrund selbst einlesen und
                 *    verarbeiten, ich will das nicht im system sehen oder
                 *    manuell machen."
                 *
                 * Der Server legt selbst ab, was er sicher zuordnen kann. Was
                 * uebrig bleibt, braucht wirklich eine Entscheidung.
                 *
                 * DER PUNKT ERSCHIEN DESHALB NUR, WENN ETWAS LAG - UND DAS WAR
                 * FALSCH.
                 *
                 * ORIGINALTEXT MARVIN (25.08.2026)
                 *   „generell fehlt noch der import von den unterlagen. wo ist
                 *    das?"
                 *
                 * Er hat ihn gesucht und nicht gefunden, und es gab ihn auch
                 * nicht: der Posteingang ist NICHT nur eine Ausnahmenliste,
                 * sondern die EINZIGE Tuer, durch die eine Datei von Hand
                 * hereinkommt - Bescheide, Bauakten, Rechnungen, Fotos UND die
                 * Abruf- und BAFA-Dateien. Der Bildschirm `Import` steht auf
                 * `im_menue = false`, weil er in diesem Bildschirm aufgegangen
                 * ist.
                 *
                 * War der Eingang leer, war damit die Tuer weg. Wer eine Datei
                 * einlesen wollte, musste erst eine liegenlassen, um an den
                 * Weg zu kommen, auf dem man sie einliest.
                 *
                 * DIE URSPRUENGLICHE SORGE BLEIBT RICHTIG: ein Menuepunkt, der
                 * meistens leer ist, wird nach zwei Wochen nicht mehr
                 * angeklickt. Sie wird aber nicht dadurch geloest, dass man den
                 * Punkt versteckt, sondern durch die ZAHL daneben: was liegt,
                 * traegt sie, und was nicht liegt, traegt sie nicht.
                 */
                .filter((b) => b.gruppe === g).map((b) => (
                <button
                  key={b.schluessel}
                  aria-current={wo === b.schluessel || (b.schluessel === 'auftraege' && wo === 'akte')}
                  onClick={() => gehZu(b.schluessel)}
                >
                  {b.name}
                  {/* KEINE ZAHL AN „Aufträge".
                      ORIGINALTEXT MARVIN (03.09.2026)
                        „wie kommt hier die zahl bei den aufträgen zu stande?
                         Ich würde da am besten garkeine einblenden."
                      Seine Frage ist die Antwort: hier stand die Summe aus
                      neu, laufend und überfällig, und in der Liste darunter
                      „Alle 403". Beide Zahlen waren richtig, und keine war zu
                      erklären. Eine Zahl, deren Bedeutung man erfragen muss,
                      ist keine Auskunft, sondern eine Frage. Beim Posteingang
                      bleibt sie: dort zählt sie, was WIRKLICH liegt und eine
                      Entscheidung braucht. */}
                  {b.schluessel === 'eingang' && liegt > 0 && (
                    <span className="zahl"
                          title={`${liegt} Datei${liegt === 1 ? '' : 'en'} `
                               + 'liegen und brauchen eine Entscheidung'}>
                      {liegt}
                    </span>
                  )}
                </button>
              ))}
            </div>
          ))}

          {/* UND GANZ UNTEN DIE WEGE NACH DRAUSSEN.
              Sie sehen aus wie Menüpunkte, sind aber `<a>` mit `target`: ein
              Klick öffnet einen NEUEN Reiter und nimmt niemandem seine Arbeit
              weg. Der Pfeil sagt es vorher - ein Link, der so aussieht wie ein
              Bildschirm dieses Systems und dann den Browser wegträgt, ist eine
              Überraschung, die man nur einmal erlebt und danach meidet.

              WAS KEINE ADRESSE HAT, KOMMT HIER GAR NICHT AN: der Server
              liefert nur Zeilen mit Adresse aus. Ein Menüpunkt, der ins Leere
              führt, ist schlimmer als keiner. */}
          {links.length > 0 && (
            <div>
              {/* SIE KLAPPT ZU, UND SIE HEISST, WAS SIE IST.
                  ORIGINALTEXT MARVIN (08.09.2026)
                    „Im Menü ganz unten der Punkt extern soll klappbar gemacht
                     werden. Aber nur für den Innendienst. Und dann schreiben
                     wir als Text nicht extern, sondern externe links."

                  „NUR FÜR DEN INNENDIENST" IST DIE VOREINSTELLUNG UND KEIN
                  RIEGEL. Beim Innendienst ist die Gruppe zugeklappt: sein Menü
                  ist lang, und die Wege nach draussen gehört er nicht jeden
                  Tag. Bei einer Partnerfirma bleibt sie OFFEN - dort stehen
                  ein oder zwei Links, und einer davon ist das Portal der
                  Telekom, das ihr am 27.08.2026 ausdrücklich gegeben wurde.
                  **Eine Gruppe zuzuklappen, in der zwei Zeilen stehen, nimmt
                  einen Weg weg und spart keinen Platz.**

                  UND WAS EINER SELBST AUFKLAPPT, BLEIBT AUFGEKLAPPT. Der Stand
                  liegt in `benutzer.ansicht` wie jeder andere gemerkte
                  Bildschirm - eine ANSICHT und nie ein Recht: was jemand sehen
                  darf, entscheidet weiter der Server. */}
              <button type="button" className="navigruppe"
                      aria-expanded={externOffen}
                      onClick={() => {
                        const neu = !externOffen;
                        setExternOffen(neu);
                        api.ansichtMerken('menue', { extern: neu })
                          .catch(() => { /* eine gemerkte Ansicht darf nie
                                            einen Klick aufhalten */ });
                      }}>
                <span className="wachsen">Externe Links</span>
                <span className="klappe" aria-hidden="true">
                  {externOffen ? '▾' : '▸'}
                </span>
              </button>
              {externOffen && links.map((l) => (
                <a key={l.id} className="aussenlink" href={l.adresse}
                   target="_blank" rel="noreferrer noopener"
                   title={l.zweck ?? l.adresse}>
                  {/* DAS ZEICHEN, WENN EINES HOCHGELADEN IST - sonst ein
                      Feld mit dem Anfangsbuchstaben in der Kennfarbe.
                      Marvin, 27.08.2026: „mach als Icon das Telekologo rein."
                      Die Marke wird HOCHGELADEN und nicht gezeichnet: eine
                      fremde Marke aus dem Gedächtnis nachzubauen ist immer
                      falsch. Bis dahin trägt die Farbe den Link. */}
                  {l.hat_icon
                    ? <img className="linkzeichen"
                           src={`/api/links/${l.id}/icon`} alt="" />
                    : <span className="linkzeichen ersatz" aria-hidden="true"
                            style={l.farbe ? { background: l.farbe,
                                               color: '#fff' } : undefined}>
                        {String(l.name ?? '?').trim().charAt(0).toUpperCase()}
                      </span>}
                  <span className="wachsen">{l.name}</span>
                  <span className="pfeil" aria-hidden="true">↗</span>
                </a>
              ))}
            </div>
          )}

        </nav>

        <div className="fussleiste">
          <div className="person">
            {/* Das Gesicht - und ohne hochgeladenes Bild die Initialen, damit
                auf einen Blick erkennbar ist, in wessen Namen gerade
                gearbeitet wird. Beim „Login als" ist genau das die Frage, die
                man sich zu spät stellt. */}
            <Gesicht benutzerId={ich.benutzerId} name={ich.name}
                     hatBild={ich.hatBild} stempel={bildStempel} />
            <div>
              <b>{ich.name}</b>
              <span>{ich.firma ?? 'Innendienst'}</span>
            </div>
          </div>
          {ich.echterName && (
            <div className="klein" style={{ color: 'var(--neu)' }}>
              übernommen von {ich.echterName}
            </div>
          )}
          {/* MEINE ANMELDUNG GEHÖRT JEDEM, DER SICH ANGEMELDET HAT.
              Sie stand als Reiter im Modul „Benutzer und Rechte", und darauf
              hat ein Subunternehmer kein Recht. Damit konnte er sein eigenes
              Passwort nicht ändern und keinen zweiten Faktor einrichten -
              obwohl das Passwort seit Migration 030 der EINZIGE Weg herein
              ist. Ein Zugang, den man nicht selbst absichern kann, ist ein
              Zugang, den man weitergibt. */}
          <div className="reihe" style={{ gap: 6 }}>
            <button
              className="knopf"
              style={{ padding: '5px 11px', fontSize: 12 }}
              onClick={() => setMeineAnmeldung(true)}
            >
              Meine Anmeldung
            </button>
            <button
              className="knopf"
              style={{ padding: '5px 11px', fontSize: 12 }}
              onClick={() => api.abmelden().then(() => setIch(null))}
            >
              Abmelden
            </button>
          </div>
          {/* DIE VERSION IST DER WEG INS ÄNDERUNGSVERZEICHNIS - siehe
              `StandKlein`. Der Menüpunkt „Änderungen" ist mit derselben
              Lieferung gefallen; wer das Recht nicht hat, bekommt keinen
              Knopf, sondern den Text wie bisher. */}
          {/* DER BEREICH (.335): unten bei der Version, als „Netzebene 3" und
              „Netzebene 4". Nur wer zwei hat, sieht die Wahl; wer einen hat,
              sieht seinen Namen. */}
          {(ich.bereiche ?? []).length > 1 ? (
            <label className="klein bereichswahl-zeile">Bereich{' '}
              <select className="bereichswahl" value={bereich ?? ''} aria-label="Bereich wählen"
                      onChange={(e) => bereichWechseln(e.target.value)}>
                {ich.bereiche!.map((b) => <option key={b.schluessel} value={b.schluessel}>{b.name}</option>)}
              </select>
            </label>
          ) : bereichJetzt ? (
            <div className="klein leise">Bereich {bereichJetzt.name}</div>
          ) : null}
          <StandKlein auf={darf(ich, 'changelog.lesen')
            ? () => gehZu('changelog') : undefined} />
          <RechnerMelden />
        </div>
      </aside>

      <main className="buehne" ref={buehne}>
        {/* DER PULS (23.09.2026): zieht nach, was andere ändern, und meldet
            eine neue Version. Er ersetzt den StandBalken, der nur beim Öffnen
            nachsah. */}
        <Puls wasIstNeu={darf(ich, 'changelog.lesen') ? () => gehZu('changelog') : undefined} />
        {ich.echterName && (
          /* Der Balken ist absichtlich laut. Wer nicht sieht, in wessen Haut
             er steckt, traegt frueher oder spaeter etwas unter fremdem Namen
             ein und wundert sich spaeter. */
          <div className="uebernahmebalken">
            <span>
              Du bist gerade als <b>{ich.name}</b>
              {ich.firma ? ` (${ich.firma})` : ''} angemeldet und siehst nur,
              was dieser Benutzer sieht.
            </span>
            <button
              className="knopf"
              onClick={() => api.zurueckZuMir().then(() => {
                anmelderUndMenue();
                gehZu(vorUebernahme ?? 'auftraege');
                setVorUebernahme(null);
              })}
            >
              Zurück zu mir
            </button>
          </div>
        )}
        {/* .592: erst wenn der Zugang die Liste hat; ein reiner NE4-Zugang lief sonst kurz in ein 403 (auftrag.lesen). */}
        {wo === 'auftraege' && bauplan.some((b) => b.schluessel === 'auftraege') && (
          <>
            {quicklinkFehler && (
              <div className="hinweis warnung" style={{ margin: '0 0 10px' }}>
                {quicklinkFehler}{' '}
                <button type="button" className="alslink" onClick={() => setQuicklinkFehler(null)}>ausblenden</button>
              </div>
            )}
            <Arbeitsliste ich={ich} oeffne={oeffne} />
          </>
        )}
        {wo === 'akte' && akte && (
          <Auftragsakte ich={ich} id={akte} starteAuf={akteReiter}
                        reiterGewechselt={(r) => inAdresse({ wo: 'akte', akte, reiter: r })}
                        /* Und der Knopf sagt, WOHIN er führt. „← Liste" auf
                           einem Weg, der in den Terminplan zurückgeht, ist
                           eine falsche Beschriftung, keine kurze. */
                        zurueckName={bauplan.find((b) => b.schluessel === herkunft)
                                       ?.name ?? 'Liste'}
                        zurueck={() => {
                          gehZu(herkunft);
                          const y = rollMerk.current[herkunft] ?? 0;
                          let n = 0;
                          const versuch = () => { try { const r = rollbereich(); r.setze(y); if (Math.abs(r.lies() - y) > 4 && n++ < 25) setTimeout(versuch, 120); } catch { /* egal */ } };
                          if (y > 0) setTimeout(versuch, 50);
                        }} />
        )}
        {wo === 'eingang'       && <Eingang ich={ich} />}
        {wo === 'postfach'      && (
          <Postfach ich={ich} oeffne={oeffne} />
        )}
        {/* DEN MENÜPUNKT „DATEIEN" GIBT ES NICHT MEHR.
            Marvin, 27.08.2026: „datei suchen ist eine globale suche richtig?
            die kannst du komplett ausbauen für alle. wir arbeiten nur mit den
            aufträgen." Die Suche über ALLE Aufträge ist mit Migration 052
            weg, samt Recht, Modul, Seite und den beiden Wegen dahinter. Der
            Reiter „Dateien" IM Auftrag bleibt - das ist die Frage, die
            wirklich gestellt wird. */}
        {/* DIE FIRMA FUEHRT IHREN KALENDER SELBST.
            Marvin, 26.08.2026: „Außerdem müssen sie in der App den
            Verfuegbarkeitskalender fuehren." Das Recht dafuer lag im Modul
            `termine`, also hinter dem Terminplaner - einem Innendienstwerkzeug
            ueber alle Firmen. Seit Migration 040 ist es ein eigener
            Menuepunkt, genau wie früher. */}
        {wo === 'verfuegbarkeit' && <Verfuegbarkeit ich={ich} />}
        {/* ZWEI MENÜPUNKTE, EINE KOMPONENTE, ZWEI FRAGEN.
            Marvin, 01.09.2026: „der wochenplan soll seitlich in das menü
            wandern und oben raus beim terminplaner." Das Raster beantwortet
            „wo ist noch Platz", die Liste „wo muss ich morgen hin". Als
            Reiter standen sie übereinander und kosteten jeden Tag einen
            Klick; ein Menüpunkt ist ein Lesezeichen. Dieselben Daten, deshalb
            dieselbe Komponente - zwei Bildschirme wären zwei Wahrheiten über
            denselben Termin. */}
        {wo === 'termine'       && <Terminplaner ich={ich} ansicht="liste"
                                     oeffne={oeffne} />}
        {wo === 'wochenplan'    && <Terminplaner ich={ich} ansicht="plan"
                                     oeffne={oeffne} />}
        {/* HIER STAND EIN MENÜPUNKT „Karte", UND ER IST ZURÜCKGEBAUT.
         *
         * ORIGINALTEXT MARVIN (04.09.2026)
         *   „wir entfernen wieder den menüpunkt mit der karte (und was du da
         *    alles gebaut hast) und bleiben in dem popup bei «Vorbereiten»."
         *
         * .107 hat ihn auf seinen eigenen Satz hin angelegt („du kannst das
         * design auch verändern und es als menüpunkt auf der seite einbauen")
         * - und einen Tag später steht die Entscheidung anders. **Zurückgebaut
         * wird ganz, nicht halb:** die Seite, die Route hier, der Menüpunkt,
         * das Recht und das Handbuchkapitel (Migration 142). Ein Menüpunkt,
         * den man nur ausblendet, ist nicht weg - dieselbe Lehre wie bei
         * `datei.suchen` und bei der Bauleitung in Migration 066.
         *
         * WAS AUS .107 BLEIBT, IST DIE KARTE SELBST: sie steht jetzt EINMAL
         * in `teile/Kartenflaeche.tsx` und wird vom Lageplan und von der
         * Planung benutzt. */}
        {wo === 'behoerden'     && <Behoerden ich={ich} oeffne={oeffne} />}
        {wo === 'abrechnung'    && <Abrechnung ich={ich} oeffne={oeffne} />}
        {/* ABRECHNUNG, DIE EINE SEITE (.340): Gutschrift, Rechnung, Zahlung.
            „Rechnungen prüfen", „Rechnungen bezahlen", „Gebühren bezahlen" und
            „LEB-Abrechnung" sind ihre Ansichten; die alten Adressen bleiben
            erreichbar, im Menü stehen sie nicht mehr. */}
        {wo === 'rechnungswesen' && <Rechnungswesen ich={ich} oeffne={oeffne} gehZu={gehZu} />}
        {wo === 'gbgs'          && <Gbgs ich={ich} oeffne={oeffne} />}
        {wo === 'papierkorb'    && <Papierkorb ich={ich} oeffne={oeffne} />}
        {wo === 'leb_verzeichnis' && <LebVerzeichnis ich={ich} oeffne={oeffne} />}
        {wo === 'adressbuch'    && <Adressbuch ich={ich} />}
        {wo === 'ne4_adressbuch' && <Adressbuch ich={ich} bereich="ne4" />}
        {/* „RECHNUNGEN PRÜFEN" IST SCHRITT 2 DER ABRECHNUNG (.433). Die alte
            Seite hängt nirgends mehr; wer über die Glocke oder eine alte
            Adresse hierher kommt, landet in der Abrechnung bei Schritt 2. */}
        {wo === 'rechnungen'    && <Rechnungswesen ich={ich} oeffne={oeffne} gehZu={gehZu} startSchritt="schritt2" />}
        {wo === 'freigaben'     && <Freigaben ich={ich} />}
        {/* MATERIAL (.249): Bestand, Katalog, Bestellungen und Bewegungen des
            Lagers in Andernach. Vorher eine eigene Tabelle neben der Plattform. */}
        {wo === 'material'      && <Material ich={ich} />}
        {wo === 'gebuehren'     && <Gebuehren ich={ich} gehZu={gehZu} oeffne={oeffne} />}
        {wo === 'rechnungen_bezahlen' && <RechnungenBezahlen ich={ich} />}
        {wo === 'bankverbindungen' && <Bankverbindungen ich={ich} />}
        {wo === 'leb_abrechnung' && (
          <LebAbrechnung ich={ich} oeffne={oeffne} gehZu={gehZu} />
        )}
        {/* Seit Migration 038 ein eigener Menuepunkt. Der Dialog in der Akte
            beantwortet die eine Abgabe; die Frage, WELCHE Abgaben faellig
            sind, stand vorher nur in der Telegram-Meldung von neun Uhr. */}
        {wo === 'rotberichtigung' && (
          <Rotberichtigungen ich={ich} oeffne={oeffne} />
        )}
        {wo === 'auswertung'    && <Auswertung oeffne={oeffne} />}
        {wo === 'kapazitaet'    && <Kapazitaet ich={ich} />}
        {wo === 'nachrichten'   && <Nachrichten />}
        {wo === 'stammdaten'    && <Stammdaten ich={ich} />}
        {/* DIE VORDRUCKE SIND EIN ORT UND KEIN REITER.
            Marvin hat zweimal gefragt, „wo kommen die Vorlagendokumente
            rein?" - beim zweiten Mal, nachdem der Reiter in den Stammdaten
            schon dastand. Er war der siebte in einer Reihe. */}
        {wo === 'vorlagen'      && <Vordrucke ich={ich} />}
        {/* DAS HANDBUCH LAG HINTER „KONFIGURATION" und war damit für jeden
            unerreichbar, der darauf kein Recht hat - also für jeden Monteur
            und jede Partnerbauleitung. Seit Migration 052 ein Menüpunkt mit
            eigenem Leserecht, das JEDE Gruppe hat. */}
        {wo === 'handbuch'      && <Handbuch ich={ich} />}
        {/* DAS ÄNDERUNGSVERZEICHNIS. Marvin, 02.09.2026: „baue außerdem eine
            changelog seite, wo du festhälfst was wir gemacht haben, damit ich
            ggf. zu einem changelogpunkt zurückspringen kann wenn du es nicht
            richtig umgesetzt hast und nachgearbeitet werden muss". */}
        {wo === 'changelog'     && <Changelog ich={ich} />}
        {wo === 'benutzer'      && (
          <Benutzer
            ich={ich}
           
            uebernommen={() => {
              /* WOHER ICH KAM, WIRD HIER GEMERKT und nicht beim Zurückgehen
                 geraten: dort ist der Bildschirm längst ein anderer. */
              setVorUebernahme('benutzer');
              anmelderUndMenue();
              gehZu('auftraege');
            }}
          />
        )}
        {/* .544: im Bereich NE4 die Konfiguration von NE4. Marvin: „unter
            Verwaltung die Konfiguration hier nochmal aufsplittet zwischen NE3 und NE4." */}
        {wo === 'konfiguration' && (bereich === 'ne4' ? <Ne4Verwaltung ich={ich} /> : <Konfiguration ich={ich} />)}
        {wo === 'schnittstelle' && <Schnittstelle ich={ich} />}
        {wo === 'automatik'     && <Automatik ich={ich} />}
        {wo === 'system'        && <Systemzustand />}
        {wo === 'protokoll'     && <Protokoll />}
        {/* DER BEREICH NE4 (.333): Übersicht, Firmen und Teams. Die Auftragskarte,
            der Import und die Buchungsseite kommen mit L2. */}
        {wo === 'ne4_teams'     && <Ne4Teams ich={ich} />}
        {wo === 'ne4_auftraege' && <Ne4Auftraege ich={ich} oeffne={ne4Oeffne} />}
        {wo === 'ne4_anrufliste' && <Ne4Anrufliste ich={ich} />}
        {wo === 'ne4_karte'     && <Ne4Karte ich={ich} />}
        {wo === 'karte'         && <Ne3Karte ich={ich} oeffne={(id) => oeffne(id)} />}
        {wo === 'ne4_planung'   && <Ne4Planung ich={ich} />}
        {wo === 'ne4_tagesplan' && <Ne4Tagesplan ich={ich} />}
        {wo === 'ne4_wochenplan' && <Ne4Tagesplan ich={ich} start="woche" />}
        {wo === 'ne4_firmenauftraege' && <Ne4FirmenAuftraege ich={ich} />}
        {wo === 'ne4_verfuegbarkeit' && <Verfuegbarkeit ich={ich} ne4 />}
        {wo === 'ne4_zahlen'    && <Ne4Zahlen ich={ich} />}
        {wo === 'ne4_gbgs'      && <Ne4Gbgs ich={ich} />}
      </main>

      {meineAnmeldung && (
        <Dialog titel="Meine Anmeldung" untertitel={ich.name} breite={720}
                zu={() => setMeineAnmeldung(false)}>
          <MeineSicherheit
            ich={ich}
            geaendert={() => { setBildStempel(Date.now()); anmelderUndMenue(); }}
          />
        </Dialog>
      )}
    </div>
  );
}
